module.exports = __webpack_public_path__ + "img/Menu-12.08b74ea7.png";